/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import ContentFrame from '../../applicationFrame/ContentFrame';
import { ScrollAwareContext, ScrollAwareScroller, ScrollAwareAppNavStep } from '../../components/ScrollAware';
import { AppHeaderScrollableText } from '../../components/appNav/AppHeaderScrollable';
import { Button } from '../../components/buttons/Buttons';
import Spacer from '../../components/Spacer';
import { TextLink } from '../../components/TextLink';
import { ConnectedWhitePrivacyCard } from '../../components/card/PrivacyCard';
import { PolicyName } from '../../../models/PolicyModel';
import AppUtils from '../../../utilities/AppUtils';

interface Props {
  onWithdrawConsent(policyName): void;
  onAccept(): void;
  onCancel(): void;
}

class AccountPrivacyConsent extends React.Component {
  props: Props;

  render() {
    const { onWithdrawConsent, onAccept, onCancel } = this.props;

    return (
      <div>
        <ScrollAwareContext>
          <ScrollAwareAppNavStep
            submitDisabled={true}
            next={() => {}}
            onDisabledClick={() => {
              const acceptButton = document.querySelector('#accountprivacy-accept-button > button');
              document.getElementById('accountprivacy-accept-button').scrollIntoView();
              AppUtils.addFlashToElement(acceptButton);
            }}
            cancel={onCancel}
            color="white"
          />

          <ContentFrame>
            <ScrollAwareScroller>
              <AppHeaderScrollableText id="accountPrivacyConsent.title.text" />

              <ConnectedWhitePrivacyCard
                name={PolicyName.EMAIL}
                isCollapsible={false}
                defaultCollapsed={false}
              />

              <div id="accountprivacy-accept-button" className="util-inset-card-margin">
                <Button
                  className="profile-background-color-accent font-color-white"
                  type={null}
                  size="wide"
                  onClick={onAccept}
                >
                  <FormattedMessage id="privacy.doConsent.button.label" />
                </Button>
              </div>

              <Spacer size="12" />

              <TextLink
                className="util-inset-card-margin util-inset-listitem-frame-padding font-subhead font-color-gsMiddle"
                style={{ display: 'block', marginBottom: 18, textDecoration: 'underline' }}
                onClick={() => { onWithdrawConsent(PolicyName.EMAIL); }}
              >
                <FormattedMessage id="privacy.dontConsent.button.label" />
              </TextLink>

            </ScrollAwareScroller>
          </ContentFrame>
        </ScrollAwareContext>
      </div>
    );
  }
}

export default AccountPrivacyConsent;
